import { useAppDispatch, useAppSelector } from "@/stores/hook";
import { closeCompose } from "../stores/gmailSlice";
import { useGmailAccount } from "../api/useGmailAccount";
import ComposeModal from "./ComposeModal";

/**
 * App-level host for the Gmail compose modal.
 *
 * Lives in `AppLayout` so the Quick Send button on a lead/deal record can
 * dispatch `openCompose({ leadId, prefill: { to: [...] } })` from any route
 * and the modal renders consistently — same component, same z-index, same
 * shortcut behaviour as inside the Gmail tab. The Gmail tab's own copy is
 * left in place because it's slightly cheaper to render conditionally there
 * (saves the React Query subscription on every page load).
 *
 * If the user hasn't connected Gmail yet we drop the dispatch silently
 * (the lead-card button handles the not-connected case via tooltip), so
 * here we just bail when there's no account.
 */
export default function GmailComposeHost() {
  const dispatch = useAppDispatch();
  const compose = useAppSelector((s) => s.gmail.compose);
  const { account } = useGmailAccount();

  if (!compose.open || !account) return null;

  return (
    <ComposeModal
      state={compose}
      onClose={() => dispatch(closeCompose())}
      fromAddress={account.email}
    />
  );
}
